import React from 'react';
import './work-list.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Listas de trabajo'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;